import { Route, Routes } from "react-router-dom";
import {
    AdminDashboard,
    Dashboard,
    DistributionDashboard,
    InvoicingDashboard,
    LabDashboard,
    MedicalChartDashboard,
    ProcessingDashboard,
    QualityAssuranceDashboard,
    RecoveryDashboard,
    ReferralDashboard,
    ShipmentsDashboard,
    SurgeryDashboard,
} from "..";
import { ProtectedRoute } from "../../component-library";
import { Claims } from "../../models";
import { ReferralDashboardProvider } from "../../contexts";

export function DashboardRoutes() {
    return (
        <Routes>
            <Route
                path="admin"
                element={
                    <ProtectedRoute claim={Claims.ViewInternal}>
                        <AdminDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="distribution"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <DistributionDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="invoicing"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInvoice}>
                        <InvoicingDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="lab"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <LabDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="medical-chart"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <MedicalChartDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="processing"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <ProcessingDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="quality-assurance"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <QualityAssuranceDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="recovery"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <RecoveryDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="referral"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewInternal}>
                        <ReferralDashboardProvider>
                            <ReferralDashboard />
                        </ReferralDashboardProvider>
                    </ProtectedRoute>
                }
            />
            <Route
                path="surgery"
                element={
                    <ProtectedRoute isAuthenticated claim={Claims.ViewSurgery}>
                        <SurgeryDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/shipments"
                element={
                    <ProtectedRoute isAuthenticated>
                        <ShipmentsDashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                index
                element={
                    <ProtectedRoute isAuthenticated>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}
